import authHeader from "./auth.header"
import { apiFetch } from './api.js'
import constants from './constants.js'

const fetch = apiFetch
const apiRequest = async (path, options = {}) => {
    const response = await fetch(`${constants.API_URL}${path}`, {
        ...options,
        headers: {
            'Accept': 'application/json',
            ...authHeader(),
            ...(options.headers || {})
        },
    })

    if (!response.ok) {
        let errorBody = null
        try {
            errorBody = await response.json()
        } catch (error) {
            errorBody = null
        }
        console.error('Request failed:', {
            status: response.status,
            statusText: response.statusText,
            body: errorBody
        })
        throw new Error(errorBody?.message || 'Payment API request failed')
    }

    if (response.status === 204) {
        return null
    }

    return await response.json()
}

export async function getClientSecret() { 
    const response = await fetch(`${constants.API_URL}/payment/client_secret`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.error('Request failed:', {
            status: response.status,
            statusText: response.statusText,
            body: await response.json()
        });
        throw new Error('Failed to fetch client secret');
    }

    return await response.json();
}

export async function getSubscriptionClientSecret(selectedPrice, userId) {
    return await apiRequest('/payment/subscriptions', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            subscriptionPriceId: selectedPrice,
            userId: userId
        })
    })
}

export async function getPublicKeyStripe() {
    const response = await fetch(`${constants.API_URL}/options/public_key_stripe`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
        },
    });

    if (!response.ok) {
        console.error('Request failed:', {
            status: response.status,
            statusText: response.statusText,
            body: await response.json()
        });
        throw new Error('Failed to fetch public key');
    }

    const data = await response.json();
    return data;
}

export async function getCountryPurchasePrices(currency = 'eur') {
    const normalizedCurrency = String(currency || 'eur').toLowerCase()
    return await apiRequest(`/payment/countries/prices?currency=${encodeURIComponent(normalizedCurrency)}`)
}

export async function createCountryPurchase(priceId, userId) {
    return await apiRequest('/payment/countries', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            priceId,
            userId,
        })
    })
}

export async function getCountryPurchaseByUser(userId) {
    return await apiRequest(`/payment/countries/${userId}`)
}

export async function getCountryPurchasePremium(userId) {
    return await apiRequest(`/payment/countries/${userId}/premium`)
}

export async function getPurchasedCountriesByUser(userId) {
    return await apiRequest(`/payment/countries/${userId}/purchased`)
}

export async function getAiTokenPrices(currency = 'eur') {
    const normalizedCurrency = String(currency || 'eur').toLowerCase()
    return await apiRequest(`/payment/ai-tokens/prices?currency=${encodeURIComponent(normalizedCurrency)}`)
}

export async function createAiTokenPurchase(priceId) {
    return await apiRequest('/payment/ai-tokens', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ priceId })
    })
}

export async function getUserTokens(userId) {
    return await apiRequest(`/users/${userId}/tokens`)
}

export async function getAiTokenPurchaseHistory(userId) {
    return await apiRequest(`/payment/ai-tokens/${userId}`)
}

export async function selectCountryPurchaseCountries(purchaseId, userId, countryCodes) {
    return await apiRequest(`/payment/countries/${purchaseId}/select`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            userId,
            countryCodes,
        })
    })
}